// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__xQ1Dp","logo-img":"Logo_logo-img__0+Qjw"};